export default __webpack_public_path__ + "fonts/NetflixSansMedium.woff";